import AppModal from '@/components/AppModal/AppModal';
import RegularText from '@/components/RegularText';
import { useTranslation } from 'react-i18next';

interface Props {
  open: boolean;
  onCancel: () => void;
  onSubmit: () => void;
  loading?: boolean;
}

export const RevertDefaultModal = ({ open, onCancel, onSubmit, loading }: Props) => {
  const { t } = useTranslation('translation');

  return (
    <AppModal
      open={open}
      onCancel={onCancel}
      cancelText={t('revert.cancel')}
      submitText={t('revert.submit')}
      title={t('revert.title')}
      onSubmit={onSubmit}
      loading={loading}
    >
      <RegularText>{t('revert.desc')}</RegularText>
    </AppModal>
  );
};
